import { TFunction } from 'i18next';

import { CompanyContactRole, PaymentMode } from 'src/Services/API/generated';

export const COMPANY_CONTACT_ROLES = [
  CompanyContactRole.Main,
  CompanyContactRole.Accounting,
  CompanyContactRole.Technical,
  CompanyContactRole.Other,
];

export const getCompanyRoleLabel = (
  t: TFunction,
  role: CompanyContactRole,
  customLabel?: string
): string => {
  switch (role) {
    case CompanyContactRole.Main:
      return t('contacts.company.roles.MAIN', 'Contact principal');
    case CompanyContactRole.Accounting:
      return t('contacts.company.roles.ACCOUNTING', 'Comptabilité');
    case CompanyContactRole.Technical:
      return t('contacts.company.roles.TECHNICAL', 'Technique');
    default:
      return customLabel ?? t('contacts.company.roles.OTHER', 'Autre');
  }
};

// The six usual modes offered to families; OTHER exists in the API but is not proposed.
export const USUAL_PAYMENT_MODES = [
  PaymentMode.DirectDebit,
  PaymentMode.Transfer,
  PaymentMode.Check,
  PaymentMode.Cash,
  PaymentMode.Card,
  PaymentMode.Cesu,
];

export const getPaymentModeLabel = (t: TFunction, mode: PaymentMode): string => {
  switch (mode) {
    case PaymentMode.DirectDebit:
      return t('contacts.company.paymentModes.DIRECT_DEBIT', 'Prélèvement');
    case PaymentMode.Transfer:
      return t('contacts.company.paymentModes.TRANSFER', 'Virement');
    case PaymentMode.Check:
      return t('contacts.company.paymentModes.CHECK', 'Chèque');
    case PaymentMode.Cash:
      return t('contacts.company.paymentModes.CASH', 'Espèces');
    case PaymentMode.Card:
      return t('contacts.company.paymentModes.CARD', 'Carte bancaire');
    case PaymentMode.Cesu:
      return t('contacts.company.paymentModes.CESU', 'CESU');
    default:
      return t('contacts.company.paymentModes.OTHER', 'Autre');
  }
};

/** "123 456 789 00012" */
export const formatSiret = (siret: string) =>
  siret.replace(/^(\d{3})(\d{3})(\d{3})(\d{5})$/, '$1 $2 $3 $4');
